import React from "react";
import { SpellDto } from "../Types/ApiTypes";
import { getAllSpells } from "../Utils/LocalApi";



export const AllSpellsContext = React.createContext<SpellDto[]>([]);

const AllSpellsProvider: React.FC<{children: React.ReactNode}> = ({children}) => {
    const [allSpells, setAllSpells] = React.useState<SpellDto[]>([]);

      if (allSpells.length === 0)
          getAllSpells().then((value) => {
        //console.log(value);
            let newSpells = [] as SpellDto[];
            value.forEach((element: SpellDto) => {
              newSpells.push(element);
              setAllSpells([...newSpells]);
            });
        });

    return (
        <AllSpellsContext.Provider value={allSpells}>
          {children}
        </AllSpellsContext.Provider>
      );
};

export default AllSpellsProvider;